import React from 'react';
import { NavLink, Outlet, Navigate, useLocation } from 'react-router-dom';
import '../Reports.css';

const NAV = [
  { to: '/reports/overview', label: 'Overview', icon: '📊' },
  { to: '/reports/financials', label: 'Financials', icon: '💰' },
  { to: '/reports/property', label: 'Property', icon: '🏢' },
] as const;

const ReportsLayout: React.FC = () => {
  const location = useLocation();

  if (location.pathname === '/reports' || location.pathname === '/reports/') {
    return <Navigate to="/reports/overview" replace />;
  }

  return (
    <div className="reports-shell">
      <header className="reports-topbar">
        <div>
          <h1 className="reports-topbar__title">Reports</h1>
          <p className="reports-topbar__sub">Performance, finances, and property occupancy</p>
        </div>
      </header>

      <div className="reports-body">
        <aside className="reports-side">
          <p className="reports-side__label">REPORTS</p>
          <nav className="reports-side__nav">
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  `reports-side__link${isActive ? ' reports-side__link--active' : ''}`
                }
              >
                <span className="reports-side__icon" aria-hidden>
                  {item.icon}
                </span>
                <span>{item.label}</span>
              </NavLink>
            ))}
          </nav>
        </aside>

        <main className="reports-main">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default ReportsLayout;
